import { gql } from "@apollo/client";

export const GET_CHEMICAL_RULE_VIOLATIONS = gql`
  query ChemicalRuleViolations($systemId: Int!) {
    getChemicalRuleViolationsBySystemId(systemId: $systemId) {
      systemId
      violationNumber
      violationId
      facilityCode
      seasonality
      typeCode
      violationType
      violationBeginDate
      violationEndDate
      determinationDate
      analyteGroup
      pointsEffective
      returnToCompliance
      appealReason
      appealResolution
      dateAppealed
      dateEmailed
      appealSuccessful
    }
  }
`;
